import {
  LIST_REPORT_SURVEY,
  LIST_REPORT_SURVEY_SUCCESS,
  LIST_REPORT_SURVEY_CLEAN,
  LIST_REPORT_SURVEY_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  report: [],
}

const ReportSurveyList = (state = initialState, action) => {
  switch (action.type) {
    case LIST_REPORT_SURVEY:
      state = {
        ...state,
        loading: true,
      }
      break
    case LIST_REPORT_SURVEY_SUCCESS:
      state = {
        ...state,
        report: action.payload.report,
        loading: false,
        done: true,
      }
      break
    case LIST_REPORT_SURVEY_CLEAN:
      state = initialState
      break
    case LIST_REPORT_SURVEY_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default ReportSurveyList
